<template lang="pug">
v-form(@submit.prevent="onSubmitClick" ref="form").auth-form
    v-text-field(
        label='Email' 
        name="login"
        :rules="[RULES.REQUIRED]"
        v-model="model.formData.login"
        :error="formErrors.hasError('login')"
        :error-messages="formErrors.fields.login"
    )
    v-text-field(
        label='Password' 
        type="password"
        name="password"
        :rules="[RULES.REQUIRED]"
        v-model="model.formData.password"
        :error="formErrors.hasError('password')"
        :error-messages="formErrors.fields.password"
    )
    v-btn(block color="primary" type="submit" :disabled="loading").mt-4 Login
</template>

<script>
import { REQUIRED } from "@/util/validation-rules";
 
export default {
  name: 'LoginComponent',

  props: {
    model: {
      type: Object,
      required: true
    },
    loading: Boolean,
    formErrors: Object
  },
    
  data: () => ({
    RULES: {
      REQUIRED
    }
  }),

  methods: {
    onSubmitClick() {
      this.$emit('submit')
    },

    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>
